module.exports = __webpack_public_path__ + "img/ct_hitpt.203690c1.png";